import { autorun } from 'mobx'
import { InferenceData } from 'type/inference'
import { createButton } from 'ui/preview/button/button'
import { createCarousel } from 'ui/preview/Carousel/Carousel'
import back_svg from 'ui/preview/icon/back.svg?source'
import close_svg from 'ui/preview/icon/close.svg?source'
import forward_svg from 'ui/preview/icon/forward.svg?source'
import css from 'ui/preview/preview.module.scss'
import { preview, PreviewStore } from 'ui/preview/store/PreviewStore'

let destroy = () => undefined

type Props = {
  inference_id: string
  inferences: InferenceData[]
}

export function openPreview({ inference_id, inferences }: Props) {
  destroy()

  if (!inference_id) return
  if (!inferences?.length) return

  preview.open(new PreviewStore(inferences))
  preview.it.index = inferences.findIndex(it => it.inference_id === inference_id)

  const len = inferences.length

  const focus = createButton('')
  focus.style.inset = '0 0 auto 0'
  focus.style.zIndex = '-1'

  const close = createButton(close_svg)
  close.style.inset = '8px 8px auto auto'
  close.addEventListener('click', event => {
    event.stopPropagation()
    destroy()
  })

  const left = createButton(back_svg)
  left.style.inset = '0 auto 0 8px'
  left.addEventListener('click', event => {
    event.stopPropagation()
    setIndex(--preview.it.index)
  })

  const right = createButton(forward_svg)
  right.style.inset = '0 8px 0 auto'
  right.addEventListener('click', event => {
    event.stopPropagation()
    setIndex(++preview.it.index)
  })

  const root = document.createElement('div')
  root.classList.add(css.fullscreen!)
  root.appendChild(focus)
  root.appendChild(close)
  root.appendChild(left)
  root.appendChild(right)

  const [carousel, unmountCarousel] = createCarousel()
  root.appendChild(carousel)

  root.addEventListener('click', (event) => {
    if (event.target === root) destroy()
  })

  function onKeyDown(event: KeyboardEvent) {
    const { code } = event
    if (code === 'Escape') {
      destroy()
    } else if (code === 'ArrowLeft') {
      setIndex(--preview.it.index)
    } else if (code === 'ArrowRight') {
      setIndex(++preview.it.index)
    }
  }

  document.addEventListener('keydown', onKeyDown)

  destroy = () => {
    unmountCarousel()
    document.removeEventListener('keydown', onKeyDown)
    root?.remove()
    destroy = () => undefined
  }

  function setIndex(value: number) {
    preview.it.index = value
  }

  setIndex(preview.it.index)

  autorun(() => {
    const { index } = preview.it
    left.disabled = index < 1
    right.disabled = index > len - 2
  })

  document.body.appendChild(root)

  // focus dirty hack
  focus.focus()
  focus.style.visibility = 'hidden'
}
